import { GetterTree } from 'vuex';
import { NotificationStateI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<NotificationStateI, RootStateI> = {
};
